// This function checks if the fulfillment object has a valid answer, intent, and intentFAQ.
// It also checks if a conversation is required for the intent - if so, fulfillment is considered available.
// It returns true if all conditions are met, otherwise false.

import { InputFulfillmentResponse } from '../api/getInputFulfillment';
import { FaqData } from '../attachments/MessageAssist';
import { NLU_FALLBACK_INTENT, SPEAK_WITH_LIVE_PERSON_INTENT } from '../intents';

export default function isFulfillmentAvailable(
    fulfillment: InputFulfillmentResponse | undefined,
    intentFaqData: FaqData | undefined
): boolean {
    return (
        (fulfillment?.answer &&
            fulfillment?.intent &&
            !fulfillment?.intent?.startsWith(SPEAK_WITH_LIVE_PERSON_INTENT) &&
            !fulfillment?.intent?.startsWith(NLU_FALLBACK_INTENT) &&
            !!intentFaqData) ||
        !!intentFaqData?.requiresConversation
    );
}
